import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Box, Typography, Button, ListItem, IconButton } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import SelectBox from '../CustomizedUIs/CustomSelectBox';
import CustomPoper from '../CustomizedUIs/CustomPoper';
import { useDataProvider, useTranslate, Loading } from 'react-admin';
import { useHistory, Link } from 'react-router-dom';
import TextField from '../CustomizedUIs/CustomTextFiled';
import { DEVICE_AUTHENTICATION_LIST } from '../utils';
import { red, pink } from '@material-ui/core/colors';
import SelectBoxFilter from '../common/select-box-filter';
import { ArrowBack, DeleteOutline } from '@material-ui/icons';
import LoadingPage from '../common/loading-page';
import TextButton from '../CustomizedUIs/TextButton';

const bgColorError = pink['50'];
const textColorError = red['700'];

const useStyles = makeStyles(theme => ({
    boxBorder: {
        borderBottom: '1px solid',
        borderRight: '1px solid',
        borderBottomColor: theme.palette.grey['200'],
        borderRightColor: theme.palette.grey['200'],
    },
    textValue: {
        fontFamily: 'UniviaPro',
        fontSize: '13px',
        fontWeight: 'normal',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 1.385,
        letterSpacing: '0.13px',
        color: '#88898c',
    },

    inputPopper: {
        alignSelf: 'flex-end',
        position: 'absolute',
        right: '12px',
        top: '10px'
    },
    iconButton: {
        margin: 'auto',
        borderRadius: '10px',
        color: 'white',
        backgroundColor: theme.palette.primary.main,
        padding: '8px'
    },
    removeIcon: {
        borderRadius: '10px',
        color: '#237fc2',
        backgroundColor: '#c1e5fa',
        padding: 4
    }
}));

const fakeData = [
    { id: 1, type: 'airties' },
    { id: 2, type: 'amino' },
    { id: 3, type: 'lg' },
    { id: 4, type: 'philip' },
    { id: 5, type: 'universal' },
    { id: 6, type: 'motorola' }
]

const FormUpdate = ({ isEdit, ...props }) => {
    const classes = useStyles()
    const dataProvider = useDataProvider()
    const translate = useTranslate()
    const history = useHistory();
    const [deviceProfile, setDeviceProfile] = useState({});

    const [anchorEl, setAnchorEl] = useState(null);
    const [openPoper, setOpenPopper] = useState(false);
    const [remoteControlType, setRemoteControlType] = useState('')
    const [deviceAuthentication, setDeviceAuthentication] = useState('')
    const [openDeviceAuthentication, setOpenDeviceAuthentication] = useState(false)
    const [messageError, setMessageError] = useState('')
    const [loading, setLoading] = useState(true);
    const [saving, setSaving] = useState(false);
    const [listRemoteControlType, setListRemoteControlType] = useState([]);
    const [nativeApps, setNativeApps] = useState([]);
    const [textValue, setTextValue] = useState({
        name: '',
        description: '',
    })
    const [error, setError] = useState({
        name: { status: deviceProfile.id ? false : true, message: '' },
    });

    const handleClickOpenPoper = (event) => {
        setAnchorEl(event.currentTarget);
        setOpenPopper(true);
    };

    const handleClosePoper = () => {
        setOpenPopper(false);
    };

    const onChangTextValue = (prop) => (e) => {
        setTextValue({
            ...textValue, [prop]: e.target.value
        })
        validate(prop, e.target.value)
    }

    const validate = (prop, value) => {
        if (prop === 'name') {
            if (value.length === 0) {
                setError({
                    ...error, [prop]: value.length === 0 ? {
                        status: true, message: translate('pos.messages.required')
                    } : {
                            status: false, message: ''
                        }
                })
            }
            else {
                setError({
                    ...error, [prop]: { status: false, message: '' }
                })
            }
        }
        else if (prop === 'nativeApp') {
            if (value.length === 0) {
                setError({
                    ...error, [prop]: value.length === 0 ? {
                        status: true, message: translate('pos.messages.required')
                    } : { status: false, message: '' }
                })
            }
            else {
                setError({
                    ...error, [prop]:
                        { status: false, message: '' }
                })
            }
        }
    }

    const onCreate = () => {
        setSaving(true);
        dataProvider('CREATE', 'device-profile', {
            data: {
                name: textValue.name,
                description: textValue.description,
                deviceAuthentication: deviceAuthentication,
                remoteControlType: remoteControlType ? remoteControlType.id : null,
                nativeApps: JSON.stringify(nativeApps)
            }
        }).then(() => {
            goBackToList();
        }).catch(({ message }) => {
            setSaving(false);
            setMessageError(translate(message));
        });
    }

    const onEdit = () => {
        setSaving(true)
        dataProvider('UPDATE', 'device-profile', {
            id: deviceProfile.id,
            data: {
                name: textValue.name,
                description: textValue.description,
                deviceAuthentication: deviceAuthentication,
                remoteControlType: remoteControlType ? remoteControlType.id : null,
                nativeApps: JSON.stringify(nativeApps)
            }
        }).then(() => {
            goBackToList();
        }).catch(({ message }) => {
            setSaving(false);
            setMessageError(translate(message));
        });
    }

    const getDeviceProfile = () => {
        dataProvider('GET_ONE', "device-profile", {
            id: deviceProfile.id
        }).then(({ data }) => {
            setLoading(false);
            setTextValue({
                name: data.name,
                description: data.description,
            })
            setDeviceAuthentication(data.deviceAuthentication)
            setRemoteControlType(data.remoteControlType)
            setDeviceProfile(data);
            setNativeApps(JSON.parse(data.nativeApps));
        }).catch(error => {
            console.error('GET DEVICE PROFILE ERROR:', error);
            goBackToList();
        });
    }

    const getListRemoteControlType = () => {
        dataProvider('GET_LIST', "remotes", {
            filter: {},
            pagination: { page: 1, perPage: -1 },
            sort: {
                field: 'name',
                order: 'DESC'
            },
        }).then(({ data }) => {
            setListRemoteControlType(data);
            setLoading(false);
        }).catch(error => {
            console.error('GET REMOTES ERROR:', error);
            goBackToList();
        });
    }

    const goBackToList = () => {
        history.push({
            pathname: '/DeviceProfiles'
        });
    }

    const onClickDeviceAuthentication = (value) => {
        setDeviceAuthentication(value)
        setOpenDeviceAuthentication(false)
    }

    const onChangeRemoteControlType = (value) => {
        setRemoteControlType(value)
    }

    const handleDisable = () => {
        if (textValue.name === '' || deviceAuthentication === '' || remoteControlType === '') return true;
        if (saving) return true;
        return false
    }

    const onChangeNativeApp = (prop, index) => (event) => {
        const newApps = nativeApps.map((item, idx) => {
            if (index === idx) {
                return {
                    ...item,
                    [prop]: event.target.value
                }
            } else {
                return item;
            }
        });
        setNativeApps(newApps);
    }

    const onAddNativeApp = () => {
        const newApps = [...nativeApps];
        newApps.push({
            name: '',
            appId: ''
        });
        setNativeApps(newApps);
    }

    const onRemoveNativeApp = (index) => {
        const newApps = nativeApps.filter((_, idx) => idx !== index);
        setNativeApps(newApps);
    }

    useEffect(() => {
        getListRemoteControlType()
        setDeviceAuthentication(DEVICE_AUTHENTICATION_LIST[0].value)
        const deviceProfileId = props.match.params.id;
        if (deviceProfileId) {
            deviceProfile.id = deviceProfileId;
            getDeviceProfile();
        } else {
            setLoading(false);
        }
    }, []);

    if (loading) return <Loading />
    return (
        <Box width='80%' m='auto'>
            <LoadingPage show={saving} />
            <Box my={5} width={300} display='flex' component={Link} to={'/DeviceProfiles'} style={{ textDecoration: 'none' }}>
                <Box display='flex' mr={2}>
                    <IconButton className={classes.iconButton}>
                        <ArrowBack />
                    </IconButton>
                </Box>
                <Typography variant="subtitle1" color="primary" style={{ margin: 'auto 0', fontWeight: 'bold' }}>{translate(`pos.devices.back`)}</Typography>
            </Box>
            <Box display='flex' justifyContent='center'>
                <Box width={500}>
                    <Typography variant='h5' style={{ fontFamily: 'UniviaPro-Medium', fontWeight: 'normal', color: '#4f5064' }}>{isEdit ? translate(`pos.channels.editting`) + deviceProfile.name : translate(`pos.devices.add`)}</Typography>
                    <Box>
                        {
                            messageError != "" && (
                                <Box borderRadius='6px' my={1} width={500} bgcolor={bgColorError} py={1}>
                                    <Typography variant='subtitle2' style={{ color: textColorError, margin: '1em' }}>{messageError}</Typography>
                                </Box>
                            )
                        }
                        <Box my={2}>
                            <TextField
                                required
                                id='name'
                                style={{ width: 500 }}
                                label={translate(`pos.dashboard.name`)}
                                onBlur={() => { validate('name', textValue.name) }}
                                value={textValue.name}
                                onChange={onChangTextValue('name')}
                                error={error.name.message !== '' && error.name.status}
                                helperText={error.name.message}
                                endDom={<CustomPoper
                                    open={openPoper}
                                    anchorEl={anchorEl}
                                    handleClick={handleClickOpenPoper}
                                    handleClose={handleClosePoper}
                                    title={translate(`pos.devices.popperTitle`)}
                                    content={translate(`pos.devices.popperContent`)}
                                    icon={<b>?</b>}
                                />} />
                        </Box>
                        <Box my={2}>
                            <TextField
                                style={{ width: 500 }}
                                variant='filled'
                                label={translate(`pos.devices.table_field.description`)}
                                multiline
                                rows={2}
                                value={textValue.description}
                                onChange={onChangTextValue('description')}
                                endDom={
                                    <Box>
                                        <Box className={classes.inputPopper}>
                                            <CustomPoper
                                                open={openPoper}
                                                anchorEl={anchorEl}
                                                handleClick={handleClickOpenPoper}
                                                handleClose={handleClosePoper}
                                                title={translate(`pos.support.description`)}
                                                content={translate(`pos.devices.description`)}
                                                icon={<b>?</b>}
                                            />
                                        </Box>
                                    </Box>
                                }
                            />
                        </Box>
                        <Box my={2}>
                            <SelectBox
                                disabled={true}
                                label={translate(`pos.devices.table_field.device_authentication`)}
                                value={<Typography className={classes.textValue}>{deviceAuthentication}</Typography>}
                                open={openDeviceAuthentication}
                                handleClick={() => { setOpenDeviceAuthentication(!openDeviceAuthentication) }}
                                required={true}
                            >
                                {
                                    DEVICE_AUTHENTICATION_LIST.map((item, index) => {
                                        return (
                                            <ListItem key={index} className={classes.boxBorder} style={{ padding: '8px' }} button onClick={() => onClickDeviceAuthentication(item.value)}>
                                                <Typography className={classes.textValue}>{item.value}</Typography>
                                            </ListItem>
                                        )
                                    })
                                }
                            </SelectBox>
                        </Box>
                        <Box my={2}>
                            <SelectBoxFilter
                                data={listRemoteControlType}
                                label={translate(`pos.devices.remoteControlType`)}
                                value={remoteControlType ? remoteControlType.name : ''}
                                onChange={(value) => onChangeRemoteControlType(value)}
                                keyName='name'
                                placeholder={translate('pos.devices.remoteControlTypePlaceholder')}
                                isRequired={true}
                            />
                        </Box>
                        <Box my={2}>
                            <Button variant='contained' color='secondary' onClick={onAddNativeApp}>
                                {translate(`pos.devices.table_field.addNativeApp`)}
                            </Button>
                        </Box>
                        {
                            nativeApps.map((app, index) => (
                                <Box my={2} display="flex" key={"native-app-" + index}>
                                    <TextField
                                        style={{ flex: 4 }}
                                        label={translate(`pos.devices.table_field.app_name`)}
                                        variant='filled'
                                        value={app.name}
                                        onChange={onChangeNativeApp('name', index)}
                                    />
                                    <Box flex={0.5} />
                                    <TextField
                                        style={{ flex: 4 }}
                                        label={translate(`pos.devices.table_field.app_id`)}
                                        variant='filled'
                                        value={app.appId}
                                        onChange={onChangeNativeApp('appId', index)}
                                    />
                                    <Box flex={0.5} pt={1.5} pl={0.5}>
                                        <IconButton className={classes.removeIcon} onClick={() => onRemoveNativeApp(index)}>
                                            <DeleteOutline />
                                        </IconButton>
                                    </Box>
                                </Box>
                            ))
                        }
                        <Box my={2} display='flex' width='100%' justifyContent='flex-end' alignItems='flex-end'>
                            <TextButton style={{ marginRight: '30px' }} component={Link} to={{ pathname: "/DeviceProfiles" }} />
                            <Button disabled={handleDisable()} style={{ padding: 8 }} variant='contained' color='primary' onClick={deviceProfile.id ? onEdit : onCreate}>
                                {deviceProfile.id ? translate(`pos.common.save`) : translate(`pos.common.create`)}
                            </Button>
                        </Box>
                    </Box>
                </Box>
            </Box>
        </Box>
    )
}

FormUpdate.propTypes = {
    isEdit: PropTypes.bool
};

export default FormUpdate